import { MENSAGENS_PADRAO } from '../constants/mensagens.const';

export function mensagemCampoObrigatorio(rotulo?: string | null): string {
  const nomeCampo = String(rotulo ?? '').trim();
  if (!nomeCampo) {
    return MENSAGENS_PADRAO.CAMPO_OBRIGATORIO;
  }
  return `${nomeCampo} é obrigatório.`;
}

export function mensagemCamposObrigatorios(rotulos: string[]): string {
  const campos = rotulos
    .map((rotulo) => String(rotulo ?? '').trim())
    .filter((rotulo) => rotulo.length > 0);

  if (campos.length === 0) {
    return MENSAGENS_PADRAO.CAMPO_OBRIGATORIO;
  }

  if (campos.length === 1) {
    return mensagemCampoObrigatorio(campos[0]);
  }

  return `Campos obrigatórios: ${campos.join(', ')}.`;
}
